import api from "../..";
import type { Article, GetArticlesParams, GetSuggestedArticlesParams } from "./types";
import type { ApiResponse } from "../../types";

export const getArticles = async ({ params }: GetArticlesParams = {}): Promise<Article[]> => {

  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item) => queryParams.append(key, item.toString()));
        } else {
          queryParams.set(key, value.toString());
        }
      }
    });
  }

  return await api.get<ApiResponse<Article[]>>(`admin/articles/${queryParams.toString() ? "?" + queryParams.toString() : ""}`)
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getSuggestedArticles = async ({ currentId, params }: GetSuggestedArticlesParams): Promise<Article[]> => {

  const list = await getArticles({
    params: {
      limit: 6,
      ordering: "-likes_count",
      ...params,
    },
  });

  return list.filter((a) => (currentId ? a.id !== currentId : true));
};
